/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import {Link} from 'gatsby'
import Header from "./header"
import { Heading,Box,Button,Flex ,Text,List,ListItem} from "@chakra-ui/react"
import MyContext from '../context/MyContext'
import useLocalStorage from "../hooks/use-local-storage"
import {FaHouseUser,FaThumbsUp,FaThumbsDown} from 'react-icons/fa'


const Me = () => {
  const { sprache } = React.useContext(MyContext)
  const [so, setSo] = React.useState("")
  const [pupil, setName] = useLocalStorage("pupil", "")
  
  return (
    <Box mx="3">
      {typeof window !== "undefined" && pupil !== "" ? (
        <Text ml="4" fontSize="md" letterSpacing="0.09rem" color="green.400">
          Hi {pupil}!
        </Text>
      ) : (
        <input
          type="text"
          placeholder={
            sprache === 0
              ? "Gib deinen Namen ein!"
              : sprache === 1
              ? "Enter  your name!"
              : sprache === 2
              ? "Введіть ім'я!"
              : "Entrez votre nom"
          }
          value={pupil ? `Hi, ${pupil}!` : so}
          onChange={e => setSo(e.target.value)}
        />
      )}
      {so !== "" && pupil === "" ? (
        <Button size="sm" ml="6" onClick={() => setName(so)}>
          go
        </Button>
      ) : (
        ""
      )}
    </Box>
  )
}

const Layout = ({ children }) => {
 
  const [pupil]=useLocalStorage("pupil",null)
  const [sprache,setSprache]=React.useState(1)
  const [zugestimmt,setZustimmung]=useLocalStorage("zugestimmt","")
  const [solu,setSolu]=useLocalStorage("solu","")
  const [urd,setUrd]=React.useState(false)
  const [flag,setFlag]=React.useState(true)
  //const [ms,setMs]=useLocalStorage("msprache","")

  const data = useStaticQuery(graphql`

    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)
  if(zugestimmt!=="zugestimmt"){
    return(
    
  
        <Box p="4" as="div" m="0 auto" maxWidth="1200">
        
     
     <Header  siteTitle={data.site.siteMetadata?.title || `Title`} />
     <Box p="2">
     <Heading fontSize="xl" my="4  ">Datenschutz</Heading>
     <Text>Datenschutzbeauftragte: René Broich.<br/> Email: kulturnetz-oberes-mittelrheintal.org</Text>
     <Text>Wir verwenden Google Analytics nur, um zu sehen, ob die ehrenamtliche Arbeit nicht vergeblich ist. Wir selbst vom K.O.M nutzen Google Analytics in anonymisierter Form. Das heißt, Google darf diese Webseite mit Iheren persönlichen Daten nicht verknüpfen.</Text>
     <Text>Als Videoplattform nutzen wir Vimeo. Laden Sie ein Video, dann gelten die Datenschutzbestimmungen von Vimeo.</Text>
     <Text>Für externe Links lehnen wir jede Verantwortung ab.</Text>
     <Link to="/datenschutz">&rarr; Bitte lesen Sie unsere Datenschutzbestimmungen für weitere Informationen.</Link><br/>
     <Button my="4" color="text" onClick={()=>setZustimmung("zugestimmt")}>Ich stimme zu</Button>
     </Box>
      </Box>
    
      
    )
  }
  return (
    <>

       <MyContext.Provider value={{pupil,solu,sprache,urd,setUrd}}>
      <Box as="div" px="0" m="0 auto" maxWidth="1000" border="1px black solid" bg="gray.800" shadow="md">
      <Button size="xs" color="white" onClick={()=>setSolu(!solu)}>{solu?<FaThumbsUp/>:<FaThumbsDown/>}</Button>
      
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
      {flag&&
      <Flex   mx="auto" flexDirection={["column","column","row"]} flexWrap="wrap" justifyContent="space-between" mb="4" mt="10" maxWidth="600">
     
        <Button m="1"
        
        _focus={{
          boxShadow:
            '0 0 1px 2px rgba(88, 144, 255, .75), 0 1px 1px rgba(0, 0, 0, .35)',
        }}
        size="sm" onClick={()=>setSprache(0)}>Deutsch</Button>
        <Button m="1"
     
        _focus={{
          boxShadow:
            '0 0 1px 1px rgba(88, 144, 255, .75), 0 1px 1px rgba(0, 0, 0, .35)',
        }}
        size="sm" onClick={()=>setSprache(1)}>Englisch</Button>
        <Button m="1"
        _focus={{
          boxShadow:
            '0 0 1px 1px rgba(88, 144, 255, .75), 0 1px 1px rgba(0, 0, 0, .35)',
        }}
         size="sm" onClick={()=>setSprache(2)}>Ukranisch</Button>
        <Button  m="1"
        _focus={{
          boxShadow:
            '0 0 1px 1px rgba(88, 144, 255, .75), 0 1px 1px rgba(0, 0, 0, .35)',
        }}
        size="sm" onClick={()=>setSprache(3)}>Französisch</Button>
        <Button m="1"
        _focus={{
          boxShadow:
            '0 0 1px 1px rgba(88, 144, 255, .75), 0 1px 1px rgba(0, 0, 0, .35)',
        }} size="sm" onClick={()=>setSprache(4)}>Arabisch</Button>
       </Flex>
   }  
      <Flex justifyContent="space-between">
        {
          typeof document!=="undefined" && document.location.pathname!=="/"&&<Box size="sx" ml="3" my="2"> <Link to="/"><FaHouseUser fontSize="2.2rem" /><Text ml="1" fontSize=".7rem">Menu</Text></Link></Box>
        }
      
        {flag===false?<Button m="3" my="30px" mb="4" size="xs" onClick={()=>setFlag(!flag)}>Sprachwahl</Button>:<Button mx="2" my="30px"  size="xs" onClick={()=>setFlag(!flag)}>Hide Sprachwahl</Button>}
</Flex>

  
       <Box mt="0" mb="10" mx="0">
              {" "}
              {typeof window !== undefined ? <Me /> : null}
            </Box>
        <Box as="main">{children}</Box>
        <Box as="footer" marginTop="2rem" fontSize="md">
         
          <Box maxWidth="1700">
          <List
            textAlign="center"
            mt="5"
            color="gray.400"
            margin="auto"
            textTransform="uppercase"
            fontSize="xs"
          >
            <ListItem display="inline-flex" mr="3">
              <Link to="/datenschutz">datenschutz</Link>
            </ListItem>
            <ListItem display="inline-flex" mr="3">
              <Link to="/impressum">Impressum</Link>
            </ListItem>
            <ListItem display="inline-flex" mr="3">
              <Link to="/kontakt">Kontakt</Link>
            </ListItem>
          </List>
        </Box>
      
        <Box py="3" display="flex" fontSize="xs" justifyContent="center" mx="auto" mt="3">  © {new Date().getFullYear()}, Built by René Broich
          {` `}</Box>
        </Box>
      </Box>
     
      </MyContext.Provider>
    </>
  )
  }

export default Layout

